import toastr from "toastr";

const initializeToastNotifications = () => {
  window.toastr = toastr;
  toastr.options.progressBar = true;
};

export default initializeToastNotifications;
